/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { FavoriteBorder, RunningWithErrors } from '@mui/icons-material';
import PageContainer from 'components/PageContainer/PageContainer';
import RespuestaServidor from 'pages/auxiliares/RespuestaServidor';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useError } from 'services/ErrorContext';
import { confirmacionRegistro } from 'services/servicioPut';
import Spinner from 'components/public/Spinner/Spinner';

const ConfirmacionRegistro = () => {
  const [searchParams] = useSearchParams();
  const [aprobado, setAprobado] = useState<boolean | null>(null);
  const codigoConfirmacion = searchParams.get('codigo');
  const { setError, setLoading, loading } = useError();
  const navigate = useNavigate();

  useEffect(() => {
    const confirmarUsuario = async () => {
      if (codigoConfirmacion) {
        const requestConfirmacion = { codigo: codigoConfirmacion };
        try {
          const respuesta = await confirmacionRegistro(requestConfirmacion, setError, setLoading);
          setAprobado(!!respuesta);
        } catch (error) {
          setAprobado(false);
        } finally {
          setLoading(false);
          setTimeout(() => {
            navigate('/');
          }, 5000);
        }
      } else {
        setAprobado(false);
        setTimeout(() => {
          navigate('/');
        }, 5000);
      }
    };
    confirmarUsuario();
  }, [codigoConfirmacion]);

  useEffect(() => {
    setLoading(true);
  }, []);

  return (
    <PageContainer>
      {loading || aprobado === null ? (
        <Spinner />
      ) : (
        <RespuestaServidor
          titulo={aprobado ? '¡Usuario confirmado!' : 'Ocurrió un error'}
          texto={
            aprobado
              ? 'Ya puedes loguearte normalmente. Serás redirigido a la página de inicio.'
              : 'El código no existe o ha expirado. Serás redirigido a la página de inicio.'
          }
          icono={aprobado ? FavoriteBorder : RunningWithErrors}
          textoBoton="Volver"
          colorIcono={aprobado ? 'success' : 'error'}
          paginaANavegar={'/'}
        />
      )}
    </PageContainer>
  );
};

export default ConfirmacionRegistro;
